import ChartFooter from './ChartFooter';

export { ChartFooter };
